type ReleaseLock = () => void;

const fallbackLocks = new Map<string, Promise<void>>();

const requestFallbackLock = (name: string): Promise<ReleaseLock> => {
	const previous = fallbackLocks.get(name) ?? Promise.resolve();

	let release!: ReleaseLock;
	const current = new Promise<void>((res) => {
		release = res;
	});

	fallbackLocks.set(
		name,
		previous.then(() => current)
	);

	return previous.then(() => release);
};

export const requestLock = (name: string): Promise<ReleaseLock> => {
	if (!('locks' in navigator) || !navigator.locks) {
		return requestFallbackLock(name);
	}

	return new Promise<ReleaseLock>((resolve) => {
		let holderResolve!: ReleaseLock;
		const holder = new Promise<void>((res) => {
			holderResolve = res;
		});

		navigator.locks.request(name, async () => {
			resolve(holderResolve);

			return holder;
		});
	});
};
